import { Button, DismissIcon, shadowAppPortal } from '@iheartjane/reefer';
import { useMemo } from 'react';
import ReactModal from 'react-modal';

import { useHandleIframeModal } from '@jane/shared-ecomm/hooks';

import type { LightboxProps } from './lightbox.types';

import styles from './lightbox.module.css';

const shadowAppSelector = (): HTMLElement => {
  return shadowAppPortal() || document.body;
};

/**
 * Lightbox modal for product and brand images and videos, used in the Carousel
 */
export const Lightbox = ({
  appId = 'app',
  children,
  'data-testid': testId,
  isOpen,
  onRequestClose,
}: LightboxProps) => {
  useHandleIframeModal(isOpen);
  const appElement: HTMLElement | undefined = useMemo(() => {
    return document.getElementById(appId) ?? undefined;
  }, [appId]);

  return (
    <ReactModal
      appElement={appElement}
      className={styles['lightbox']}
      overlayClassName={styles['lightbox_overlay']}
      closeTimeoutMS={200}
      contentLabel="lightbox"
      data-testid={testId}
      isOpen={isOpen}
      onAfterOpen={() => (document.body.style.overflow = 'hidden')}
      onAfterClose={() => (document.body.style.overflow = 'unset')}
      onRequestClose={onRequestClose}
      parentSelector={shadowAppSelector}
      portalClassName={styles['lightbox_portal']}
      shouldCloseOnOverlayClick={true}
    >
      <div className={styles['lightbox_buttonWrapper']}>
        <Button.Icon
          icon={<DismissIcon />}
          label="Close lightbox"
          variant="minimal-inverse"
          onClick={() => onRequestClose()}
        />
      </div>
      <div className={styles['lightbox_modalContent']}>
        <div className={styles['lightbox_content']}>{children}</div>
      </div>
    </ReactModal>
  );
};
